import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../state";
import { RootState } from "../../state";
import { DefaultButton, Dialog, DialogType, Label, Stack, StackItem, TextField } from "@fluentui/react";
import { addLoanCar, getLoanCars, removeLoanCar, addDamage, removeDamage } from "../../state/department/loanCarActions";
import CarDamageHandler from "./CarDamageHandler";
import { getDepartments } from "../../state/action";
interface Props {
    departmentId?: string;

}
const LoanCar = (props: Props) => {
    const [editMode, setEditMode] = React.useState(false);
    const departments = useSelector((state: RootState) => getDepartments(state));
    const editLoanCar = () => setEditMode(!editMode);
    const [regNumber, setRegNumber] = React.useState<string | undefined>(undefined);
    const dispatch = useDispatch<AppDispatch>() as any;
    const department = departments.find(x => x.id === props.departmentId);
    React.useEffect(() => {
        if (props.departmentId) {
            dispatch(getLoanCars(props.departmentId));
        }
    }, [props.departmentId])

    const onregNumberChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string) => {
        setRegNumber(text);
    }
    const addCar = () => {
        if (regNumber && props.departmentId) {
            dispatch(addLoanCar(props.departmentId, regNumber));
        }
    }
    const removeCar = (id: string) => () => {
        if (props.departmentId) {
            dispatch(removeLoanCar(props.departmentId, id));
        }
    }

    const addDamageClick = (carId: string) => (damage: CarDamage) => {
        if (props.departmentId) {
            dispatch(addDamage(props.departmentId, carId, damage));
        }
    }
    const removeDamageClick = (carId: string) => (damageId: string) => {
        if (props.departmentId) {

            dispatch(removeDamage(props.departmentId, carId, damageId));
        }
    }

    return <div className="loan-car-manager">
        <Label
            onClick={editLoanCar}
            className="loan-car-manager__title"
        >
            Låne biler:
        </Label>
        <span onClick={editLoanCar} className="loan-car-manager__car-list">
            {department && department.loanCars && department.loanCars.map(x => x.regNumber).join(", ")}
        </span>

        <Dialog
            minWidth={700}
            hidden={!editMode}
            onDismiss={editLoanCar}
            className="loan-car-manager__dialog"
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: "Låne biler",
                showCloseButton: true
            }}
        >
            <Stack
                horizontal={true}
                tokens={{ padding: 5, childrenGap: 10 }}
                className="loan-car-manager__input-stack"
            >
                <TextField
                    onChange={onregNumberChange}
                    title="Reg nummer"
                    className="loan-car-manager__input-field"
                />
                <DefaultButton
                    text="Tilføj låne bil"
                    onClick={addCar}
                    className="loan-car-manager__add-button"
                />
            </Stack>

            {department && department.loanCars && department.loanCars.map((x, index) => {
                const colors = ['#e6f7ff', '#fff2e6',];
                const bgColor = colors[index % colors.length]; // Cycles through colors
                return (
                    <div key={x.id} style={{ backgroundColor: bgColor }}>
                        <DefaultButton
                            text="Fjern"
                            onClick={removeCar(x.id)}
                            className="loan-car-manager__remove-button"
                            style={{ float: "right", margin: 5 }}
                        />
                        <Stack wrap={false}
                            horizontal={true}
                            tokens={{ padding: 10, childrenGap: 10 }}
                            className="loan-car-manager__car-row"
                        >
                            <StackItem grow={true} className="loan-car-manager__stack-item">
                                <Label className="loan-car-manager__label loan-car-manager__reg-number"><b>{x.regNumber}</b></Label>
                                <Label className="loan-car-manager__label">{x.make}</Label>
                                <Label className="loan-car-manager__label">{x.model}</Label>
                                <Label className="loan-car-manager__label">{x.colour}</Label>
                            </StackItem>
                            <StackItem  >
                                <CarDamageHandler
                                    damage={x.damage}
                                    addDamage={addDamageClick(x.id)}
                                    removeDamage={removeDamageClick(x.id)}
                                />
                            </StackItem>
                        </Stack>
                    </div>
                );
            })}
        </Dialog>
    </div>
}

export default LoanCar;
